
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"19","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M11 0h3a8 8 0 018 8v2.615a8 8 0 01-8 8h-3V0z","fill":"#00CA8E"}}),_c('path',{attrs:{"d":"M8 0h3v18.615H8a8 8 0 01-8-8V8a8 8 0 018-8z","fill":"#6362D6"}}),_c('g',{attrs:{"transform":"rotate(-180 8.462 7.615)","fill":"#FFF","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M1.5 0h.192v1.192a.5.5 0 01-.5.5H0V1.5A1.5 1.5 0 011.5 0z"}}),_c('rect',{attrs:{"x":"3.385","width":"1.692","height":"1.692","rx":".5"}}),_c('path',{attrs:{"d":"M7.27 0h3.076a1.5 1.5 0 011.5 1.5v.192H7.27a.5.5 0 01-.5-.5V.5a.5.5 0 01.5-.5zM7.27 10.154h4.576v.192a1.5 1.5 0 01-1.5 1.5H7.27a.5.5 0 01-.5-.5v-.692a.5.5 0 01.5-.5z"}}),_c('path',{attrs:{"d":"M10.154.846h1.692v9.5a1.5 1.5 0 01-1.5 1.5h-.192v-11z"}}),_c('rect',{attrs:{"y":"3.385","width":"1.692","height":"1.692","rx":".5"}}),_c('rect',{attrs:{"y":"6.769","width":"1.692","height":"1.692","rx":".5"}}),_c('path',{attrs:{"d":"M0 10.154h1.192a.5.5 0 01.5.5v1.192H1.5a1.5 1.5 0 01-1.5-1.5v-.192z"}}),_c('rect',{attrs:{"x":"3.385","y":"10.154","width":"1.692","height":"1.692","rx":".5"}})])])])
          )
        }
      }
    